import { IsoDate } from "./types/dates"
import { Uuid } from "./types/uuid"

export function generateIntradayBatchUrl(accountAlias: string, portfolioId: string | Uuid, date: IsoDate) {
  return `/api/${accountAlias}/p/${portfolioId}/intraday/batches/${date}/last-completed`
}
